import React from 'react';

import { useIntl } from 'react-intl';

import { A11yWrapper } from 'components/a11y-wrapper';
import { AccessibleMainContent } from 'state/ui';

import SectionHeading from '../section-heading';

const YourCartHeading: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <A11yWrapper>
      <AccessibleMainContent>
        <SectionHeading testID="cart-section-heading-label">
          {formatMessage({ id: 'yourCart' })}
        </SectionHeading>
      </AccessibleMainContent>
    </A11yWrapper>
  );
};

export default YourCartHeading;
